import { useEffect, useState } from "react";
import { MemberLayout } from "../../components/Layouts";
import { api, readUser, fmt } from "../../lib/api";
import { Copy } from "lucide-react";

export default function Referrals() {
  const user = readUser();
  const [data, setData] = useState({ members: [], counts: {}, earnings: {} });
  useEffect(() => { api.get("/referrals").then((r) => setData(r.data)).catch(() => {}); }, []);
  const link = `${window.location.origin}/register?ref=${data.referral_code || ""}`;
  return (
    <MemberLayout user={user} active="Referrals">
      <div className="deposit-grid">
        <div className="panel">
          <div className="panel-heading"><div><span className="eyebrow">YOUR LINK</span><h3>Share World Help Agency</h3></div></div>
          <div className="referral-code">
            <div><span>REFERRAL CODE</span><strong data-testid="referrals-code">{data.referral_code || "—"}</strong></div>
            <button className="icon-btn" onClick={() => navigator.clipboard?.writeText(data.referral_code || "")} data-testid="copy-code"><Copy size={14} /></button>
          </div>
          <div className="referral-code">
            <div><span>REFERRAL LINK</span><strong className="hash wrap" data-testid="referrals-link">{link}</strong></div>
            <button className="icon-btn" onClick={() => navigator.clipboard?.writeText(link)} data-testid="copy-link"><Copy size={14} /></button>
          </div>
        </div>
        <div className="panel">
          <div className="panel-heading"><div><span className="eyebrow">LEVEL STATS</span><h3>Members & earnings</h3></div></div>
          <div className="level-grid">
            {[1, 2, 3, 4].map((l) => (
              <div className="level-card" key={l} data-testid={`level-card-${l}`}>
                <span>Level {l}</span>
                <strong>{data.counts?.[l] || 0}</strong>
                <small>Earnings: ${fmt(data.earnings?.[l])}</small>
              </div>
            ))}
          </div>
          <div className="referral-total">Total referral earnings · <strong data-testid="total-referral-earnings">${fmt(data.total_earnings)}</strong></div>
        </div>
      </div>
      <div className="table-panel">
        <div className="panel-heading"><div><span className="eyebrow">MEMBERS</span><h3>Network members</h3></div></div>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Level</th><th>Name</th><th>Username</th><th>Email</th><th>Joined</th></tr></thead>
            <tbody>
              {data.members.map((m, i) => (
                <tr key={m.id} data-testid={`network-row-${i}`}>
                  <td>Level {m.level}</td>
                  <td>{m.name}</td>
                  <td>{m.username}</td>
                  <td>{m.email}</td>
                  <td>{m.joined ? new Date(m.joined).toLocaleDateString() : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {!data.members.length && <div className="table-empty">Invite your first member to grow your network.</div>}
        </div>
      </div>
    </MemberLayout>
  );
}
